module.exports = __webpack_public_path__ + "static/media/arrows-h.f8531364.svg";